module.exports = __webpack_public_path__ + "img/pdf.527bbbb6.png";